// eslint-disable-next-line import/prefer-default-export
import supplierStyleEnum from '@/enums/supplierStyleEnum';

export const csvUtils = {
  /* eslint-disable */
  jsonToCsv(jsonToTransform) {
    const json = jsonToTransform;
    const fields = Object.keys(json[0]);
    const replacer = function (key, value) {
      return value === null ? '' : value;
    };
    const csv = json.map((row) => {
      return fields.map((fieldName) => {
        return JSON.stringify(row[fieldName], replacer);
      })
        .join(';');
    });
    csv.unshift(fields.join(';')); // add header column
    return btoa(csv.join('\r\n'));
  }
};

export const basicUtils = {
  currentDate() {
    let today = new Date();
    let dd = String(today.getDate())
      .padStart(2, '0');
    let mm = String(today.getMonth() + 1)
      .padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    return dd + '-' + mm + '-' + yyyy;
  },

  dateWithoutMilli(ts) {
    return Math.floor(ts / 1000);
  },

  givenDate(ts) {
    let dd = String(ts.getDate())
      .padStart(2, '0');
    let mm = String(ts.getMonth() + 1)
      .padStart(2, '0'); //January is 0!
    let yyyy = ts.getFullYear();

    return yyyy + '-' + mm + '-' + dd;
  },

  timeFromATs(ts) {
    const date = new Date(ts);
// Hours part from the timestamp
    const hours = date.getHours();
// Minutes part from the timestamp
    const minutes = '0' + date.getMinutes();
// Seconds part from the timestamp
    const seconds = '0' + date.getSeconds();

    return hours + 'h' + minutes.substr(-2) + 'min' + seconds.substr(-2);
  },

  currentDatePostgresStyle() {
    let today = new Date();
    let dd = String(today.getDate())
      .padStart(2, '0');
    let mm = String(today.getMonth() + 1)
      .padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    return yyyy + '-' + mm + '-' + dd;
  },
  nextDay() {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    return tomorrow;
  },

  currentHourPostgresStyle() {
    let today = new Date();

    let hh = today.getHours();
    let mi = today.getMinutes();
    let ss = today.getSeconds();

    return hh + ':' + mi + ':' + ss;
  },

  dayOfTimestamp(timestamp) {
    const days = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
    return days[new Date(timestamp).getDay()];
  },

  orderBy(toOrder, key) {
    return _.orderBy(toOrder, [key]);
  },

  filter(toOrder, filteredKey, filteredValue) {
    return _.filter(toOrder, [filteredKey, filteredValue]);
  },

  shopNameFromEmail(email) {
    return email.substring(0, email.lastIndexOf('@'));
  },
};

export const jobUtils = {
  generateOrderNumber(shopId, shopType, orderCount) {
    const year = new Date(Date.now()).getFullYear();
    const ts = parseInt(Date.now()
      .toString())
      .toString(16)
      .toUpperCase();
    return `${shopId}${String.fromCharCode(year - 1949)}${shopType}${orderCount}${ts}`;
  },
};


export const cssUtils = {
  supplierBackgroundColor(supplier) {
    return supplierStyleEnum[supplier];
  },
};



